import { useEffect, useState } from "react";
import Lenis from "lenis";
import { useEdition } from "@/hooks/useEdition";
import { ReaderContext } from "@/components/magazine/ReaderContext";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { SectionsBento } from "@/components/landing/SectionsBento";
import { EditionIndex, LandingFooter } from "@/components/landing/EditionIndex";

export default function Landing() {
  const [lang, setLang] = useState("en");
  const { edition, pages, isLoading } = useEdition(lang);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); };
  }, []);

  useEffect(() => { document.documentElement.lang = lang; document.documentElement.dir = edition?.dir || "ltr"; }, [lang, edition]);

  return (
    <ReaderContext.Provider value={{ goTo: () => {}, openMedia: null, ui: edition?.ui || {}, edition, interactive: false }}>
      <main style={{ background: "var(--charcoal)", color: "var(--platinum)" }} data-testid="landing-page" dir={edition?.dir || "ltr"} lang={lang}>
        <Hero edition={edition} cover={pages[0]} lang={lang} onLang={setLang} loading={isLoading} />
        <Marquee items={pages[0]?.items?.map((i) => i.title) || ["Music", "Screen", "Style", "Influence"]} />
        <SectionsBento pages={pages} edition={edition} lang={lang} />
        <EditionIndex pages={pages} edition={edition} lang={lang} />
        <LandingFooter edition={edition} lang={lang} />
      </main>
    </ReaderContext.Provider>
  );
}
